<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="140px">
            <el-form-item label="设备编号：" prop="code">
                <el-input v-model="model.code" disabled></el-input>
            </el-form-item>
            <el-form-item label="名称：" prop="name">
                <el-input v-model="model.name" disabled></el-input>
            </el-form-item>
            <el-form-item label="设备报警：" prop="alert_device">
                <el-radio-group v-model="model.alert_device">
                    <el-radio label="1">启用</el-radio>
                    <el-radio label="0">停用</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="通道1：" prop="channel_use1">
                <el-radio-group v-model="model.channel_use1">
                    <el-radio label="1">启用</el-radio>
                    <el-radio label="0">停用</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="通道2：" prop="channel_use2">
                <el-radio-group v-model="model.channel_use2">
                    <el-radio label="1">启用</el-radio>
                    <el-radio label="0">停用</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="流量预警阈值：" prop="flow_threshold">
                <el-input v-model.number="model.flow_threshold" style="width: 150px"></el-input>（L/min）
            </el-form-item>
            <el-form-item label="压力预警阈值：" prop="pressure_threshold">
                <el-input v-model.number="model.pressure_threshold" style="width: 150px"></el-input>（Mpa）
            </el-form-item>
            <el-form-item label="抬动预警阈值：" prop="lift_threshold">
                <el-input v-model.number="model.lift_threshold" style="width: 150px"></el-input>（um）
            </el-form-item>
            <el-form-item label="工作时间类型：" prop="work_time_type">
                <el-select clearable v-model="model.work_time_type" placeholder="请选择" style="width: 150px">
                    <el-option v-for="item in enuObj('work_time_type')" :key="'work_time_type'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="工作开始时间：" prop="work_time_start" v-if="model.work_time_type==2">
                <el-input v-model="model.work_time_start" style="width: 150px"></el-input>（格式如：07:00:00）
            </el-form-item>
            <el-form-item label="工作结束时间：" prop="work_time_end" v-if="model.work_time_type==2">
                <el-input v-model="model.work_time_end" style="width: 150px"></el-input>（格式如：14:00:00）
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'
import { getAllDeviceWorkList, getAllProducerList } from '@/api/deviceuser'

export default {
    name: 'deviceCheckEdit1',
    mixins: [editutil],
    data() {
        return {
            model: {
                code: '',
                name: '',
                alias: '',
                model: '',
                time_difference: '',
                company_produce: '',
                company_use: '',
                remark: '',
                order_index: '',
                creator_id: '',
                creator_name: '',
                create_time: '',
                update_id: '',
                update_name: '',
                update_time: '',
                flow_threshold: 40,
                pressure_threshold: 3,
                lift_threshold: 100,
                work_time_type: '1',
                work_time_start: '',
                work_time_end: '',
                work_code: '',
            },
            getObj:{
                url:'/api/admin/devicecheck/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: ['work_time_type'],
            rules: {
                code: [
                    {required: true, message: '设备编号不能为空', trigger: 'blur'},
                    {validator: this.validExist, trigger: 'blur' }
                ],
                name: [
                    {required: true, message: '名称不能为空', trigger: 'blur'}
                ],
                alias: [
                    {required: true, message: '简称不能为空', trigger: 'blur'}
                ],
                model: [
                    {required: true, message: '型号不能为空', trigger: 'blur'}
                ],
                time_difference: [
                    {required: true, message: '时间差不能为空', trigger: 'blur'},
                    {type: 'number', message: '时间差必须是数字值', trigger: 'blur'}
                ],
                company_produce: [
                    {required: true, message: '生产厂家不能为空', trigger: 'blur'}
                ],
                company_use: [
                    {required: true, message: '使用单位不能为空', trigger: 'blur'}
                ],                
                order_index: [
                    {required: true, message: '顺序不能为空', trigger: 'blur'},
                    {type: 'number', message: '顺序必须是数字值', trigger: 'blur'}
                ],
                alert_device: [
                    {required: true, message: '设备报警启用状态不能为空', trigger: 'blur'},
                ],
                channel_use1: [
                    {required: true, message: '通道1启用状态不能为空', trigger: 'blur'},
                ],
                channel_use2: [
                    {required: true, message: '通道2启用状态不能为空', trigger: 'blur'},
                ],
                flow_threshold: [
                    {required: true, message: '流量预警阈值不能为空', trigger: 'blur'},
                    {type: 'number', message: '流量是数字值', trigger: 'blur'}
                ],
                pressure_threshold: [
                    {required: true, message: '压力预警阈值不能为空', trigger: 'blur'},
                    {type: 'number', message: '压力预警阈值必须是数字值', trigger: 'blur'}
                ],
                lift_threshold: [
                    {required: true, message: '抬动预警阈值不能为空', trigger: 'blur'},
                    {type: 'number', message: '抬动预警阈值必须是数字值', trigger: 'blur'}
                ],
                work_time_type: [
                    {required: true, message: '工作时间类型不能为空', trigger: 'blur'},
                ],
            },
            checkObj:{
                url:'/api/admin/devicecheck/check',
                data:{}
            },
            exits_p_name:'code',
            exits_p_title:'设备编号',
            producerList: [],
        };
    },
    methods: {
        loadOtherData() {
            getAllProducerList().then(res=>{
                if(res.code ==1){
                    this.producerList = res.data
                }
            })
        },
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/devicecheck/save'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
        formateData(){
            this.model.work_time_type = this.model.work_time_type+""
            this.model.alert_device = this.model.alert_device+""
            this.model.channel_use1 = this.model.channel_use1+""
            this.model.channel_use2 = this.model.channel_use2+""
        },
    }
};
</script>